/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styles from './CopyUrlButton.module.scss';
import CopyIcon from 'assets/images/icons/copy-product-url.svg';
import clsx from 'clsx';
import useStore from 'state/state';
import { bool } from 'prop-types';

import { CopyUrlToClipboard } from 'utils/copyToClipboard';

const CopyUrlButton = ({ animateOut }) => {
  const appData = useStore((state) => state.appData);
  const copyString = appData.mainData.overallApp.tooltips.copyLink
    ? appData.mainData.overallApp.tooltips.copyLink
    : 'Copy link';

  const linkCopied = appData.mainData.overallApp.tooltips.linkCopied
    ? appData.mainData.overallApp.tooltips.linkCopied
    : 'Link copied';

  const [isCopied, setIsCopied] = useState(false);
  const [isAnimIn, setIsAnimIn] = useState(false);
  const [labelCopy, setLabelCopy] = useState(copyString);

  useEffect(() => {
    const to = setTimeout(() => {
      setIsAnimIn(true);
    }, 1000);
  }, []);

  const copyToCB = () => {
    // CopyUrlToClipboard()
    if (CopyUrlToClipboard()) {
      setIsCopied(true);
      setLabelCopy(linkCopied);

      const to = setTimeout(() => {
        clearTimeout(to);
        setIsCopied(false);

        const to1 = setTimeout(() => {
          clearTimeout(to1);
          setLabelCopy(copyString);
        }, 100);
      }, 1500);
    }
  };

  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.animOut]: animateOut,
        [styles.animIn]: isAnimIn && !animateOut,
      })}
    >
      <button
        type="button"
        className={styles.button}
        aria-label={copyString}
        onClick={copyToCB}
      >
        <CopyIcon />
      </button>
      <div className={clsx(styles.tooltip, { [styles.visible]: isCopied })}>
        <div className={styles.before} />
        <div className={styles.bg} />
        <span className={styles.label}>{labelCopy}</span>
      </div>
    </div>
  );
};
CopyUrlButton.propTypes = {
  animateOut: bool.isRequired,
};

export default CopyUrlButton;
